import $ from 'jquery';
import Dropzone from 'dropzone';
import { createAlert } from './window';

export const reset = ($form) => {
    var $el = $form.find('[data-dropzone]');
    // reset dropzone
    if ($el.length) {
        $el.data('dropzone').removeAllFiles(true);
    }
};
export const removeFile = (file, $file) => {
    //console.log($file);
    var $form = $file.closest('.form'),
        url = $form.data('remove-file'),
        explanation = $form.find('.field__dropzone-explanation');

    if (file.accepted) {
        //console.log($file.data('id'));

        $.post(url, {
            id: $file.data('id'),
        });
    }

    $file.remove();
    explanation.show();
};
export const create = ($el, options) => {
    var basicOptions = {
        maxFilesize: 2,
        // uploadMultiple: false,
        // addRemoveLinks: true,
        // previewsContainer: $el.siblings('.form-photos')[0],
        // hiddenInputContainer: 'body',
        // createImageThumbnails: true,
        // acceptedFiles: 'image/*,application/pdf,.psd',
        success: function(file, response) {
            var $file = $(file.previewTemplate);

            // if (typeof(response.segment) !== 'undefined' && response.segment) {
            //     SegmentTracking.trigger(response.segment);
            // }

            $file.data('id', response.id);
        },
        removedfile: function(file) {
            var $file = $(file.previewTemplate);

            removeFile(file, $file);
        },
    };

    // merge options
    $.extend(basicOptions, options);

    // set url
    basicOptions.url = $el.data('url');

    $el.attr('data-dropzone', true).data(
        'dropzone',
        new Dropzone($el[0], basicOptions)
    );
};
export const bindSingleImageUpload = ($el) => {
    $el.each(function() {
        var $el = $(this),
            $explanation = $el.find('.field__dropzone-explanation'),
            $photos = $(this).find('.form-photos'),
            $form = $(this).closest('.form'),
            $template = $form.find('.form-photos-template'),
            inputName = $el.data('input-name'),
            prevFile,
            options = {
                // createImageThumbnails: true,
                acceptedFiles: 'image/png, image/jpeg, image/jpeg, image/svg+xml',
                previewsContainer: $photos[0],
                previewTemplate: $template.html(),
                thumbnailWidth: null,
                maxFiles: 1,
                maxFilesize: 3, // MB
                paramName: 'Upload',
                thumbnailHeight: 200,
                // thumbnail: function(file, dataUrl) {
                //     if (file.previewElement) {
                //         file.previewElement.classList.remove('dz-file-preview');
                //         var images = file.previewElement.querySelectorAll(
                //             '[data-dz-thumbnail]'
                //         );
                //         for (var i = 0; i < images.length; i++) {
                //             var thumbnailElement = images[i];
                //             thumbnailElement.alt = file.name;
                //             thumbnailElement.src = dataUrl;
                //         }
                //         setTimeout(function() {
                //             file.previewElement.classList.add(
                //                 'dz-image-preview'
                //             );
                //         }, 1);
                //     }
                // },
                init: function() {
                    this.on('addedfile', function() {
                        if (typeof prevFile !== 'undefined') {
                            this.removeFile(prevFile);
                        }

                        // Remove the first one if there are stuff inside
                        var $embeddedChildren = $photos.children(
                            '.form-photos__item--internal'
                        );
                        if ($embeddedChildren.length > 0) {
                            $embeddedChildren.remove();
                        }
                    });

                    this.on('success', function(file, response) {
                        $el.removeClass('field--loading');

                        prevFile = file;

                        //console.log(file, response);

                        var $file = $(file.previewTemplate),
                            $input = $(
                                '<input type="hidden" name="' +
                                    inputName +
                                    '" />'
                            ).val(response.ID);

                        $file.append($input);
                    });

                    this.on('sending', function(file, xhr, data) {
                        $el.addClass('field--loading');

                        const extraData = {
                            SecurityID: window.SecurityToken,
                        };

                        var key;
                        for (key in extraData) {
                            data.append(key, extraData[key]);
                        }
                    });
                },
                error: function(file, response) {
                    var data = {
                        message: response,
                    };

                    if (!file.accepted) {
                        createAlert(data, 'error');
                        this.removeFile(file);

                        if (!prevFile) {
                            $explanation.show();
                        }
                    }
                },
                thumbnail: function(file, dataUrl) {
                    if (!file.accepted) return;

                    var $preview = $(file.previewElement),
                        $thumb = $preview.find('.dz-details'),
                        $img = $('<img>').attr('src', dataUrl);

                    $thumb.html($img);
                    $explanation.hide();
                    // $thumb.css({
                    //     backgroundImage: 'url(' + dataUrl + ')'
                    // });
                },
            };

        create($el, options);
    });
};
export const binds = ($el) => {
    // create();
    $('[data-dropzone-image-single]').each(function() {
        bindSingleImageUpload($(this));
    });

    $('.form__photo-upload').each(function() {
        create($(this));
    });

    $('[data-dz-remove]').on('click.dropzone', function(event) {
        event.preventDefault();
        var $file = $(this)
            .parent()
            .parent();

        removeFile(
            {
                accepted: true,
            },
            $file
        );
    });
};
